import {NumberTabs} from './NumberTabs';
export default NumberTabs;